/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Stripe_RenewsInputs */

const fr_membership_stripe_renews = /** @type {(inputs: Membership_Stripe_RenewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renouvellement automatique`)
};

/**

* @param {Membership_Stripe_RenewsInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_stripe_renews = /** @type {((inputs?: Membership_Stripe_RenewsInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Stripe_RenewsInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_stripe_renews(inputs)
});